/** Browser performance marks for the search-result-to-highlight journey (Issue #3240). */
export const PROJECT_SEARCH_MARKS = {
  selection: 'project-search:selection',
  navigation: 'project-search:navigation',
  firstCanvas: 'project-search:first-canvas',
  highlightSettled: 'project-search:highlight-settled',
} as const;

/** Clears the previous journey and starts a fresh measurement at result selection. */
export function startProjectSearchJourney(): void {
  const timing = browserPerformance();
  if (!timing) return;
  for (const mark of Object.values(PROJECT_SEARCH_MARKS)) timing.clearMarks(mark);
  for (const name of [
    'project-search:selection-to-navigation',
    'project-search:selection-to-first-canvas',
    'project-search:selection-to-highlight-settled',
  ]) {
    timing.clearMeasures(name);
  }
  timing.mark(PROJECT_SEARCH_MARKS.selection);
}

/** Marks a milestone once and measures it from selection when that mark exists. */
export function markProjectSearchMilestone(milestone: Exclude<keyof typeof PROJECT_SEARCH_MARKS, 'selection'>): void {
  const timing = browserPerformance();
  if (!timing || timing.getEntriesByName(PROJECT_SEARCH_MARKS[milestone], 'mark').length > 0) return;
  if (timing.getEntriesByName(PROJECT_SEARCH_MARKS.selection, 'mark').length === 0) return;
  const mark = PROJECT_SEARCH_MARKS[milestone];
  timing.mark(mark);
  timing.measure(`project-search:selection-to-${milestoneName(milestone)}`, PROJECT_SEARCH_MARKS.selection, mark);
}

/** Converts a typed milestone key to the kebab-case suffix used by Performance measures. */
function milestoneName(milestone: Exclude<keyof typeof PROJECT_SEARCH_MARKS, 'selection'>): string {
  if (milestone === 'firstCanvas') return 'first-canvas';
  if (milestone === 'highlightSettled') return 'highlight-settled';
  return milestone;
}

/** Returns the browser Performance API when marks are supported, including in test-safe contexts. */
function browserPerformance(): Performance | null {
  return typeof performance === 'undefined' || typeof performance.mark !== 'function' ? null : performance;
}
